import { Box, Flex, Text, Button, useTheme } from '@chakra-ui/react';
import {
  PROVIDER_SUGGESTED_QUESTIONS,
  VBC_SUGGESTED_QUESTIONS,
} from '../../config';
import { ReactComponent as CaraLogo } from '../../logos/caraLogo.svg';
import { ReactComponent as QuestionLogo } from '../../logos/questionMarkLogo.svg';
import { ReactComponent as CarejourneyLogo } from '../../logos/carejourneyLogo.svg';
import {
  LANDING_PAGE_TEXT_TITLE,
  LANDING_PAGE_INTRO_TEXT,
  LANDING_PAGE_CLOSING_TEXT,
} from '../../config';
import MessageInput from './MessageInput';

const LandingPage = ({
  handleSend,
  setShowProviderLoadingScreen,
  setSearchResults,
  searchResults,
}) => {
  const theme = useTheme();
  const handleButtonClick = (question) => {
    handleSend(question);
  };
  const currentPath = window.location.pathname;
  let suggestedQuestions = [];
  let landingTitle;
  if (currentPath.includes('providerBot')) {
    landingTitle = 'CARA';
    suggestedQuestions = PROVIDER_SUGGESTED_QUESTIONS;
  } else {
    suggestedQuestions = VBC_SUGGESTED_QUESTIONS;
    landingTitle = 'VBC CHATBOT';
  }

  return (
    <Flex flexDirection='column' overflowY='auto'>
      <Flex
        alignItems='center'
        justifyContent='center'
        flexDirection='column'
        bg={theme.colors?.tableHeaderBlue}
        pb={50}
      >
        <Flex
          direction='column'
          alignItems='flex-end'
          mt={8}
          mb={6}
          width='85%'
        >
          <Box>
            <CarejourneyLogo />
          </Box>
        </Flex>

        <Box
          backgroundColor={theme.colors?.blueTwo}
          borderRadius='25px 25px 25px 0px'
          p={4}
          display='flex'
          flexDirection='column'
          justifyContent='space-between'
          width='85%'
          boxShadow={theme.shadow?.lg}
        >
          <Flex direction='row' fontSize='1.4rem' color='white' ml={5} mb={2}>
            <Text fontWeight='300'>Ask</Text>
            <Text ml={2} fontWeight='600'>
              Cara!
            </Text>
          </Flex>
          <MessageInput
            sendMessage={handleSend}
            setSearchResults={setSearchResults}
            searchResults={searchResults}
            setShowProviderLoadingScreen={setShowProviderLoadingScreen}
          />
        </Box>
        <Flex
          width='85%'
          direction='column'
          alignItems='stretch' // Added for x-axis center alignment
          justifyContent='space-between'
          mt={8}
        >
          <Flex alignItems='flex-start'>
            <Flex alignItems='center' gap='8px'>
              <QuestionLogo />
              <Text fontSize={12} color={theme.colors?.smoky}>
                Example questions to help you start!
              </Text>
            </Flex>
          </Flex>
          <Flex
            flexDirection='row'
            flexWrap='wrap'
            gap='20px'
            justifyContent='center'
            alignItems='center'
            mt={2}
          >
            {suggestedQuestions.map((el, i) => (
              <Button
                key={i}
                borderRadius='18px 18px 18px 0px'
                backgroundColor={theme.colors?.explorerBackground}
                color={theme.colors?.darkGrey3}
                padding='15px'
                fontSize='0.8rem'
                fontWeight={400}
                display='flex'
                justifyContent='flex-start'
                alignItems='center'
                gap='10px'
                flex='1 0 0'
                onClick={() => handleButtonClick(el)}
                minHeight='80px'
                whiteSpace='normal'
              >
                <Text textAlign='left'>{el} ➞</Text>
              </Button>
            ))}
          </Flex>
        </Flex>
      </Flex>
      <Flex flexDirection='row' mt='30px'>
        <Box
          mr={7}
          maxWidth={600}
          width='20%'
          backgroundColor='white'
          borderRadius={6}
          padding={5}
          display='flex'
          justifyContent='center'
          alignItems='center'
        >
          <CaraLogo />
        </Box>
        <Box>
          <Text
            fontSize='12px'
            mt={4}
            color={theme.colors?.darkBlue}
            fontWeight='bold'
            lineHeight='14px'
          >
            {LANDING_PAGE_TEXT_TITLE}
          </Text>
          <Text mt={2} fontSize={12} color={theme.colors?.smoky}>
            {LANDING_PAGE_INTRO_TEXT}
          </Text>
          <Text mt={2} fontSize={12} color={theme.colors?.smoky}>
            {LANDING_PAGE_CLOSING_TEXT}
          </Text>
        </Box>
      </Flex>
    </Flex>
  );
};

export default LandingPage;
